import { render, staticRenderFns } from "./MarketTemplatePage.vue?vue&type=template&id=3de2f809&scoped=true"
import script from "./MarketTemplatePage.vue?vue&type=script&lang=js"
export * from "./MarketTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./MarketTemplatePage.vue?vue&type=style&index=0&id=3de2f809&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2f809",
  null
  
)

export default component.exports